// Portuguese texts (default language, always loaded)
/* eslint-disable */
const pt = {
  feat: {
    how: "Como funciona?",
    learn_more: "Saber mais",
    nav: "Funcionalidades",
    overline: "Como funciona o tierTCG",
    title: "Funcionalidades",
    lede: "Tudo o que podes fazer no tierTCG, explicado de forma simples. Escolhe um tema.",
    toc: "Nesta página",
    install_btn: "Instalar o tierTCG",
    install_done: "Já tens o tierTCG instalado neste aparelho.",
    sections: [
      {
        "id": "nivel-de-loja",
        "title": "Nível de loja e Apoio ⚡",
        "intro": "O Nível de loja mostra as lojas que a comunidade mais apoia nesta temporada.",
        "points": [
          [
            "Voto ou apoio?",
            "O voto ▲▼ é a tua opinião sobre a loja e conta para o ranking da comunidade. O apoio ⚡ é uma ajuda do dia a uma loja, nesta temporada."
          ],
          [
            "Como apoiar",
            "Toca no ⚡ ao lado de uma loja no Nível de loja, na página inicial. Tens 3 apoios por dia para distribuir."
          ],
          [
            "Quem pode apoiar",
            "Membros com conta ativa há algum tempo, para que os apoios venham de pessoas reais."
          ]
        ]
      },
      {
        "id": "temporadas",
        "title": "Temporadas e Hall da Fama",
        "intro": "O Nível de loja funciona por temporadas de 3 meses.",
        "points": [
          [
            "No fim de cada temporada",
            "Tudo recomeça do zero e qualquer loja pode chegar ao topo."
          ],
          [
            "Hall da Fama",
            "As melhores lojas de cada temporada ficam no Hall da Fama para sempre, com um selo na página delas."
          ]
        ],
        "link": [
          "/hall-da-fama",
          "Ver o Hall da Fama →"
        ]
      },
      {
        "id": "recompensas",
        "title": "Recompensas por apoiar",
        "intro": "Apoiar também te dá recompensas a ti.",
        "points": [
          [
            "Todos os dias",
            "Cada apoio dá-te uma pequena recompensa."
          ],
          [
            "Sequência diária",
            "Apoiar vários dias seguidos dá prémios cada vez melhores. Quem não falhar um mês inteiro leva um item lendário."
          ],
          [
            "Desafios da semana",
            "Todas as semanas há desafios novos, com recompensas para quem os completa."
          ],
          [
            "E mais…",
            "Há surpresas pelo caminho. Descobre-as!"
          ]
        ]
      },
      {
        "id": "rankings",
        "title": "Rankings",
        "intro": "Cada categoria (lojas, eventos e criadores) tem dois rankings.",
        "points": [
          [
            "Ranking tierTCG",
            "É a avaliação da equipa tierTCG, feita em visitas reais e com critérios para cada tipo de entrada. Os votos da comunidade não o mudam."
          ],
          [
            "As notas podem mudar",
            "Voltamos às lojas: uma nova visita pode subir ou descer a pontuação. A data da última avaliação tierTCG aparece na página de cada loja."
          ],
          [
            "Ranking da comunidade",
            "É feito pelos votos dos membros: um voto por entrada, ▲ ou ▼, que podes mudar quando quiseres. Cada entrada começa com 2 ▲ e 2 ▼ “neutros”, para que poucos votos não a façam subir ou cair demasiado. Quanto mais votos, mais conta a % positiva real. Entradas com menos de 5 votos levam a etiqueta “Poucos votos”."
          ],
          [
            "Setas",
            "Mostram os lugares ganhos ou perdidos na última semana."
          ]
        ]
      },
      {
        "id": "conquistas",
        "title": "Conquistas e antiguidade",
        "intro": "As conquistas aparecem no teu perfil e mostram o teu percurso no tierTCG.",
        "points": [
          [
            "Antiguidade",
            "Uma medalha que sobe com o tempo da tua conta."
          ],
          [
            "Por participar",
            "Votar, comentar e explorar o site desbloqueia medalhas."
          ],
          [
            "Especiais",
            "Algumas são raras, outras só existiram uma vez, como a de Fundador. E há as que ficam por descobrir."
          ]
        ]
      },
      {
        "id": "pixie",
        "title": "A Pixie",
        "intro": "A Pixie é a tua mascote em pixel art. Vive no teu perfil e cresce contigo.",
        "points": [
          [
            "Packs e inventário",
            "Abre packs, colecciona acessórios e veste a tua Pixie. Os itens têm número (#001…), por isso cada cópia é só tua."
          ],
          [
            "Todos os dias",
            "Há sempre qualquer coisa à tua espera."
          ],
          [
            "Mais para descobrir",
            "Novas atividades vão abrindo à medida que sobes de nível."
          ]
        ]
      },
      {
        "id": "niveis",
        "title": "Níveis e XP dos membros",
        "intro": "Tu também tens um nível. Sobe-o ao participar no site.",
        "points": [
          [
            "Como ganhar XP",
            "Votar, comentar, visitar o site e cuidar da tua Pixie dá XP."
          ],
          [
            "A tua gema",
            "Ao subir de nível ganhas gemas novas, que aparecem no teu perfil."
          ]
        ]
      },
      {
        "id": "app",
        "title": "Instalar como app",
        "intro": "O tierTCG funciona como uma app, no telemóvel e no computador: abre com um toque, em ecrã inteiro, sem lojas de apps.",
        "install": true,
        "points": [
          [
            "iPhone e iPad",
            "No Safari, toca em Partilhar (o quadrado com a seta) e depois em “Adicionar ao ecrã principal”."
          ],
          [
            "Android",
            "No Chrome, toca em ⋮ e depois em “Instalar app” ou “Adicionar ao ecrã principal”."
          ],
          [
            "Computador",
            "No Chrome ou no Edge, clica no ícone de instalar na barra de endereço, à direita."
          ]
        ]
      }
    ],
  },
  h29: {
    pm_level: "Nível {n}",
    pm_unlock: "Abre no nível {n}",
    see_all: "Ver tudo",
    what_is: "O que é isto?",
    search: "Procurar loja",
    search_ph: "Procura uma loja ou cidade…",
    search_none: "Nenhuma loja encontrada.",
    no_support_yet: "Ainda sem apoios · sê o primeiro ⚡",
    months: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    season: "Temporada {n}",
    lvl_title: "Nível de loja",
    ends_in: "acaba em {n} dias",
    ends_1: "acaba amanhã",
    ends_0: "acaba hoje",
    verified: "Votos verificados ✓",
    top_max: "★ nível máximo · {n} dias no topo",
    top_max0: "★ nível máximo",
    gap_season: "faltam {n} para subir a #{r}",
    week: "+{n} esta semana",
    see_store: "Ver loja",
    hint: "Toca no ⚡ para apoiar · 3 apoios por dia",
    see_rewards: "ver recompensas",
    empty: "A temporada começou! Sê o primeiro a apoiar uma loja ⚡",
    empty_cta: "Ver lojas",
    streak: "Sequência diária",
    hof_card_champ: "Campeã da {s}",
    hof_card_first: "A primeira campeã é coroada a {d}. Pode ser a tua loja!",
    scepter_how: "30 dias seguidos de apoio ⚡ dão o Cetro do Raio + 5 packs 1.ª Edição.",

    days: "{n} dias",
    day1: "1 dia",
    today: "hoje {n}/{m}",
    ladder: { 1: "+1 shard", 3: "+5 shards", 5: "baú bónus", 7: "Promo Pack", 30: "Cetro + 5 packs" },
    sign_streak: "Entra para começares a tua sequência",
    rewards: "Recompensas",
    rw: [
      ["Apoia 3 lojas por dia", "+1 Holo Shard por apoio (máx. 3 por dia)"],
      ["Sequência diária", "3 dias: +5 shards · 5: baú bónus · 7: Promo Pack · 30: Cetro do Raio + 5 packs 1.ª Edição"],
      ["Apoiaste a campeã?", "10+ apoios à vencedora da temporada → conquista “Visionário”"],
      ["Desafio da semana", "“Apoia 3 lojas diferentes” → +30 XP"],
      ["Pódio da temporada", "O top 3 entra no Hall da Fama para sempre"],
    ],
    hof_link: "Hall da Fama →",
    sb_over: "Apoio diário · {s}",
    sb_title: "Apoia esta loja",
    sb_sub: "Dá +1 XP à loja no Nível de loja",
    sb_btn: "Apoiar",
    sb_done_title: "Apoiado hoje!",
    sb_done_sub: "+1 XP para {e} · volta amanhã",
    sb_done_btn: "Feito",
    sb_pips: "Os teus apoios hoje:",
    sb_first: "O voto é a tua opinião; o apoio ⚡ é uma ajuda diária à loja (3 por dia).",
    sb_shard: "+1 Holo Shard pelo teu {n}.º apoio de hoje",
    sb_rank: "#{r} nesta temporada · {x} XP",
    sb_rank0: "Ainda sem apoios nesta temporada",
    sb_login: "Entra para apoiar",
    sb_out: "Já usaste os 3 apoios de hoje",
    err: {
      new_account: "Podes apoiar 24 h depois de criares a conta.",
      seed: "Confirma a tua frase de recuperação (perfil) para apoiar lojas.",
      level: "Chega ao nível 2 para apoiar lojas.",
      daily_max: "Já usaste os 3 apoios de hoje. Volta amanhã!",
      already: "Já apoiaste esta loja hoje.",
      network: "Esta loja já recebeu muitos apoios desta rede hoje.",
      banned: "Esta conta não pode apoiar lojas.",
      not_store: "Só as lojas podem ser apoiadas.",
      generic: "Não foi possível apoiar agora.",
    },
    streak_got: "Sequência de {n} dias! {r}",
    scepter_got: "30 dias! O Cetro do Raio e 5 packs estão no teu inventário ⚡",
    tick_support: "⚡ Novo apoio em {e}",
    tick_leader: "⚡ Novo líder da temporada: {e}",
    hof_over: "As campeãs de cada temporada",
    hof_title: "Hall da Fama",
    hof_sub: "A cada 3 meses a temporada acaba: a loja com mais apoios ⚡ fica campeã e fica aqui para sempre.",
    hof_empty: "A Temporada 1 acaba a 31 de dezembro. A campeã vai ser a primeira loja desta parede.",
    hof_now: "Ver a temporada atual",
    champ: "Campeã",
    place2: "2.º lugar",
    place3: "3.º lugar",
    days_top: "{n} dias no #1",
    xp: "{n} XP",
    supporters: "{n} apoiantes",
    visionaries: "{n} Visionários",
    seal1: "Campeã · {s}",
    seal2: "2.º lugar · {s}",
    seal3: "3.º lugar · {s}",
    pm_title: "A tua Pixie",
    pm: { packs: "Abrir packs", inventory: "Inventário", shop: "Loja", chest: "Baú diário", fish: "Ir pescar", garden: "Jardim" },
    pm_profile: "Ver a minha Pixie",
  },
  h27: {
    type: ["Procura uma loja no mapa…", "Encontra lojas perto de ti…", "Lojas em Lisboa, Porto, Braga…", "Onde jogar TCG na tua cidade…"],
    search_label: "Procurar lojas, eventos, criadores",
    near: "Perto de mim",
    near_denied: "Localização bloqueada: permite-a no browser para usar \"Perto de mim\".",
    search_ph: "Procura uma loja no mapa…",
    recent: "Pesquisas recentes",
    cities: "Cidades mais procuradas",
    no_results: "Nada encontrado para \"{q}\".",
    clear_recent: "Limpar",
    close: "Fechar",
    cat: { stores: "Loja", vending: "Vending", events: "Evento", creators: "Criador" },
    top_over: "Ranking tierTCG",
    top_title: "Top lojas",
    comm_over: "Ranking da comunidade",
    comm_title: "Top comunidade",
    positive: "positivos",
    tab_vote: "Votar",
    swipe: "desliza →",
    tick_vote_up: "Novo voto a favor em {e}",
    tick_vote_down: "Novo voto contra em {e}",
    tick_comment: "Novo comentário em {e}",
    ago_now: "agora mesmo",
    ago_min: "há {n} min",
    ago_h: "há {n} h",
    chart_total: "Total de votos",
    chart_net: "líquido",
    see_all: "Ver todas →",
    pts: "pts",
    tab_finder: "Finder",
    tab_events: "Eventos",
    tab_profile: "Perfil",
    pixie_hi: "Olá! Eu sou a Pixie",
    pixie_sub: "Com uma conta grátis podes:",
    pixie_b: ["Votar e comentar nas tuas lojas e eventos", "Adotar-me e abrir packs de cosméticos", "Ganhar Holo Shards, XP e conquistas", "Jardim, pesca e desafios semanais"],
    pixie_join: "Criar conta grátis",
    pixie_login: "Entrar",
    kit_over: "Só para o dono desta loja",
    kit_title: "Kit de divulgação",
    kit_lede: "Mostra aos teus clientes que estás no tierTCG. Cada QR traz-te votos e comentários.",
    kit_qr: "visitas pelo QR",
    kit_qr_month: "este mês",
    kit_votes: "votos este mês",
    kit_rank: "no ranking",
    kit_poster: "Poster",
    kit_story: "Story Instagram",
    kit_cert: "Certificado",
    kit_download: "Descarregar",
    kit_print: "Imprimir / PDF",
    kit_making: "A preparar…",
    p_title_1: "Avalia-nos",
    p_title_2: "no tierTCG",
    p_cta: "Aponta a câmara · vota · comenta",
    p_foot: "Vota, comenta e descobre as melhores lojas de TCG em Portugal",
    chart_title: "Votos ao longo do tempo",
    chart_private: "Só tu (dono) e o tierTCG veem isto.",
    chart_up: "a favor",
    chart_down: "contra",
    chart_event: "evento",
    chart_empty: "Ainda sem votos neste período.",
    host_store: "Loja organizadora",
    host_none: "— nenhuma —",
  },
    nav: { admin: "Admin", finder: "Finder", submit: "Sugerir", top: "Membros", profile: "Perfil", language: "Idioma" },
    home: {
      overline: "Portugal · Jogos de Cartas · Desde 2026",
      title_1: "A tier list",
      title_2: "definitiva",
      title_3: "do",
      title_4: "cenário",
      title_5: "TCG português.",
      lede:
        "Descobre onde jogar e comprar TCG em Portugal: lojas, eventos e criadores, com notas de visitas reais e votos da comunidade.",
      cta_explore: "Explorar Rankings",
      cta_vote: "Votar Agora",
      cta_near: "Mapa de lojas",
      category_prefix: "Categoria",
    },
    pulse: {
      overline: "Ao vivo pela comunidade",
      title: "O Pulso",
      lede: "Os votos da comunidade, ao minuto.",
      rising: "A Subir",
      rising_sub: "Mais upvotes",
      falling: "A Cair",
      falling_sub: "Mais downvotes",
      empty_rising: "Ainda sem upvotes nesta categoria.",
      empty_falling: "Ainda sem downvotes nesta categoria.",
      cta: "Ver ranking completo",
      votes: "votos",
    },
    upcoming: {
      overline: "Marca na agenda",
      title: "Eventos Em Breve",
      lede: "Os próximos eventos que valem a viagem!",
      when: "Próximo",
      next_date: "Próxima data",
      tickets_where: "Venda de bilhetes",
      price: "Entrada",
      tickets: "Bilhetes",
      venue: "Local",
      follow: "Seguir no Instagram",
      t_online: "Online",
      t_inperson: "Presencial",
      t_both: "Online e presencial",
      see: "Ver eventos em breve",
    },
    notif: {
      title: "Notificações",
      empty: "Ainda não há novidades.",
      replied: "respondeu ao teu comentário",
      liked: "gostou do teu comentário",
      on: "em",
      level_up: "Chegaste ao nível {n}! Continua assim.",
      chest_ready: "O teu baú diário está pronto a abrir!",
      vote_burst: "Pico suspeito de votos em {e}: vê a Moderação.",
      app_error: "Novo erro no site: {e}",
      referral: "@{u} completou as tarefas do convite: a tua recompensa chegou!",
      airdrop: "🎁 Recebeste um airdrop!",
      suggestion_ok: "✅ {k} que sugeriste, «{n}», foi aprovado(a)! +15 Holo Shards.",
      sugg_kind: { stores: "A loja", events: "O evento", creators: "O criador", vending: "A máquina" },
      referral_self: "Primeiras tarefas feitas! A recompensa do convite de @{u} chegou.",
      bait_ready: "O teu isco foi recarregado. Bora pescar!",
      garden_ready: "O teu jardim tem {n} plantas prontas a colher!",
    },
    top: {
      crumb: "Top membros",
      title: "Top membros",
      lede_month: "Quem ganhou mais XP este mês. Recomeça no dia 1.",
      lede_all: "Os níveis mais altos de sempre.",
      month: "Este mês",
      all: "Sempre",
      empty: "Ainda ninguém ganhou XP este mês — sê o primeiro!",
      you_are: "Estás em #{n} com {xp} XP.",
      not_ranked: "Ganha XP este mês para entrares no ranking.",
      my_position: "A minha posição",
      open_spot: "Lugar livre",
      you: "tu",
      to_pass: "Faltam {xp} XP para passares {user}.",
      you_lead: "Estás em #1. Continua assim!",
      behind_you: "{user} está a {xp} XP de ti.",
    },
    sup: {
      over: "Apoiante tierTCG",
      title: "Ajuda o tierTCG a crescer",
      lede: "O tierTCG é feito com tempo e carinho, sem anúncios a mandar nos rankings. Quem apoia ajuda a manter o site vivo e recebe:",
      perks: [
        ["Conquista exclusiva", "A medalha Apoiante no teu perfil, para sempre."],
        ["No carrossel de apoiantes", "O teu @username, ou o logo da tua marca, a rolar no rodapé do site."],
        ["Acesso antecipado", "Experimentas as novidades antes de toda a gente."],
        ["Linha direta com o admin", "Os teus tickets vão para uma caixa especial e são respondidos primeiro."],
      ],
      pay: "Apoiar no Buy Me a Coffee",
      ask: "Quero ser apoiante",
      after: "Depois de apoiares, abre o pedido com o teu @username para ativarmos as vantagens.",
      ask_only: "Abre um pedido e combinamos contigo como apoiar.",
      note: "O apoio nunca influencia os rankings.",
      form_title: "Pedido de apoiante",
      form_lede: "Diz-nos quem és e como queres aparecer no carrossel. Respondemos aqui e recebes uma notificação.",
      role: { member: "Membro", brand: "Empresa / marca" },
      type_fixed: "Apoio",
      subject: "Quero ser apoiante do tierTCG",
      msg_ph: "Ex.: Já apoiei no Buy Me a Coffee como … · Quero aparecer como @… (ou com o logo da minha loja).",
      box: "⭐ Apoiantes",
      notif: "És oficialmente Apoiante do tierTCG! Obrigado 💛",
    },
    nudge: {
      title: "Cria conta grátis",
      text: "Vota, comenta e ganha o teu primeiro pack da Pixie.",
      cta: "Criar conta",
      close: "Fechar",
    },
    rate: {
      nav: "Como avaliamos",
      overline: "Ranking tierTCG",
      title: "Como avaliamos",
      lede: "As notas tierTCG não são votos nem opiniões soltas: vêm de visitas reais, com os mesmos critérios para todos.",
      blocks: [
        ["Visitas reais", "Visitamos cada loja, máquina e evento como um cliente normal. A nota só aparece depois de uma visita."],
        ["Os mesmos critérios para todos", "Cada tipo de entrada tem os seus critérios, pontuados da mesma forma em todo o país."],
        ["As notas podem mudar", "Voltamos às lojas. Uma nova visita pode subir ou descer a pontuação, e a data da última avaliação tierTCG está sempre na página de cada loja."],
        ["Independente", "Ninguém paga por uma nota. Patrocínios e apoiantes nunca mudam os rankings."],
        ["E a comunidade?", "O ranking da comunidade é separado: é feito pelos votos dos membros e não mexe na nota tierTCG."],
      ],
      criteria_title: "O que conta",
      criteria_lede: "Estes são os critérios de cada tipo de entrada.",
      kinds: { stores: "Lojas", vending: "Máquinas de vending", events: "Eventos", creators: "Criadores" },
      cta: "Ver os rankings",
      cta2: "Como funcionam os rankings",
    },
    ui: { close: "Fechar", remove: "Remover" },
    tickets: {
      title: "Fala com a equipa tierTCG",
      my: "Os meus tickets",
      new: "Novo ticket",
      lede: "Dúvidas, sugestões ou reclamações sobre o site: respondemos aqui e recebes uma notificação.",
      as: "Sou",
      role: { member: "Membro", brand: "Marca / negócio" },
      kind: "Tipo",
      type: { question: "Dúvida", suggestion: "Sugestão", complaint: "Reclamação" },
      subject: "Assunto",
      message: "Mensagem",
      images: "Imagem (opcional, 1 · JPG, PNG ou WebP, até 5 MB)",
      too_big: "Essa imagem é demasiado grande (máx. 5 MB).",
      bad_image: "Só imagens JPG, PNG ou WebP.",
      aff_box: "Pedido de afiliação",
      aff_role: { owner: "Dono", representative: "Representante" },
      add_image: "Adicionar imagem",
      send: "Enviar",
      sent: "Ticket enviado. Respondemos aqui e recebes uma notificação.",
      limit: "Já tens 3 tickets abertos. Fica um lugar livre quando a equipa fechar um deles. Entretanto, podes responder num que já tens.",
      day_limit: "Abriste muitos tickets hoje. Tenta outra vez amanhã.",
      closed_list: "Tickets fechados ({n})",
      closed_note: "A equipa fechou este ticket. Se precisares de mais ajuda, abre um novo.",
      signin: "Entra na tua conta para abrir um ticket. É assim que te conseguimos responder.",
      status: { open: "Aberto", answered: "Respondido", closed: "Fechado" },
      empty: "Ainda não tens tickets.",
      reply: "Responder",
      reply_ph: "Escreve uma resposta…",
      you: "Tu",
      team: "Equipa tierTCG",
      about: "Sobre",
      notif: "A equipa tierTCG respondeu ao teu ticket",
      failed: "Não foi possível enviar. Tenta outra vez.",
    },
    garden: {
      title: "Jardim",
      of: "O jardim de {u}",
      open: "Jardim",
      ready_n: "{n} prontas!",
      locked: "Jardim · nível {n}",
      care: "Cuidar",
      decorate: "Decorar",
      herbarium: "Plantdex",
      night: "Noite",
      day: "Dia",
      confirm: "Confirmar",
      fence: "Vedação",
      fence_locked: "Achado raro nas colheitas",
      got_fence: "Achado raro: Cerca Branca! Experimenta-a em Decorar.",
      water_all: "Regar tudo",
      harvest_all: "Colher tudo",
      seed_day: "Semente do Dia",
      seed_day_got: "Semente do Dia: {p}!",
      seeds: "Saco de sementes",
      no_seeds: "Ainda não tens sementes. Abre baús, faz desafios ou compra Pacotes de Sementes na Loja.",
      pick_seed: "Plantar o quê?",
      empty_slot: "Lugar vazio num canteiro. Toca para plantar.",
      grows_in: "Pronta em {t}",
      next_stage: "Próxima fase em {t}",
      ready: "Pronta a colher!",
      water: "Regar",
      watered: "Regada nesta fase",
      water_tip: "Uma rega por fase deixa essa fase 20% mais rápida.",
      planted: "{p} plantada",
      watered_n: "{n} regadas",
      nothing_water: "Já está tudo regado.",
      harvested: "{n} colhidas",
      xp_capped: "Limite de XP do jardim por hoje atingido",
      got_pack: "+{n} pack!",
      got_hat: "Chapéu de Jardineiro! (exclusivo)",
      cross: "Polinização cruzada! {a} × {b} → semente de {p}",
      new_decor: "Nova decoração: {d}",
      green_thumb: "Mão Verde desbloqueado!",
      bug_hint: "Um escaravelho dourado! Toca-lhe.",
      bug_got: "Escaravelho dourado apanhado: semente de {p}!",
      stage: ["Semeada", "Rebento", "A crescer", "Madura"],
      hours: "{n}h",
      rarity: { common: "Comum", uncommon: "Invulgar", rare: "Rara", legendary: "Lendária" },
      herb_lede: "Colhe cada planta uma vez. Cada linha completa dá uma decoração; as 16 dão a medalha Mão Verde. Toca numa planta para veres a sua página.",
      lore: {
        clover: "As fadas escondem um raminho de quatro folhas em cada canteiro. A Pixie jura que já o encontrou duas vezes.",
        mint: "As nixies mastigam as suas folhas para terem o hálito fresco antes de cantarem aos marinheiros.",
        daisy: "A Freya entrançava-as no cabelo. Ainda se viram para quem lhes sorri.",
        tulip: "As nereides plantam-nas nas poças da maré. Encosta uma ao ouvido e ouves as ondas.",
        fern: "O sítio preferido do Pan para a sesta. As frondes cantarolam quando o vento está de feição.",
        helios: "Um botão dorminhoco que abre no instante em que o primeiro raio de sol lhe toca.",
        peony: "Dizem que só abre para corações bondosos. As pétalas da Psique são macias como asas de borboleta.",
        hydra: "Colhe uma flor e nascem duas. Os jardineiros chamam-lhe a flor mais generosa que existe.",
        lily: "A cada cem colheitas explode em chamas douradas inofensivas e volta a crescer mais brilhante.",
        sunflower: "Passa o dia a seguir o carro de Rá pelo céu. À noite sonha com o sol.",
        lavender: "O Morfeu guarda um raminho debaixo da almofada. Um cheirinho e sonhas a cores.",
        rose: "Cresceu nos campos de batalha das sagas antigas. Dizem que os espinhos protegem os corações valentes.",
        orchid: "A Íris pintou cada pétala com uma risca de arco-íris, por isso não há duas iguais.",
        cactus: "O coração de um gigante de pedra em forma de planta: lento, leal e um bocadinho espinhoso.",
        holo: "As pétalas brilham como uma carta holo. Os colecionadores dizem que dá sorte nas aberturas.",
        axiom: "A primeira árvore, de onde cresceram todas as regras do jardim. Mais antiga do que qualquer tier list.",
      },
      dex: { grow: "Tempo de crescimento", harvested: "Colhidas", first: "Primeira colheita", undiscovered: "Ainda por descobrir. Colhe-a uma vez para preencher esta página." },
      herb_row_reward: "Prémio da linha: {d}",
      herb_done: "Feito",
      unknown: "???",
      harvests: "×{n}",
      decor_lede: "Arrasta as decorações para o terreno e toca em ✓. Afasta dois dedos para fazer zoom.",
      storage: "Guardado",
      storage_empty: "Nada guardado.",
      rotate: "Rodar",
      store: "Guardar",
      save: "Confirmar",
      cancel: "Cancelar",
      saved: "Jardim guardado",
      blocked: "Não cabe aí",
      expand: "Expandir terreno",
      expand_lede: "Junta uma nova faixa de terra à borda.",
      expand_level: "A partir do nível {n}",
      expand_lvl_short: "Nível {n}",
      expand_max: "O teu terreno já está no máximo.",
      expand_ok: "Terreno expandido!",
      buy: "Comprar",
      shop_more: "Pacotes de Sementes e decorações estão na Loja.",
      decor: {
        bed: "Canteiro", pond: "Lago", fence_picket: "Cerca Branca", fence_rustic: "Cerca Rústica", stones: "Pedras do Caminho",
        lantern: "Lanterna", bench: "Banco", mushroom: "Cogumelos", birdbath: "Bebedouro", wishing_well: "Poço dos Desejos", prism_fountain: "Fonte Prisma",
      },
      plants: {
        clover: "Trevo das Fadas", mint: "Menta Nixie", daisy: "Margarida de Freya", tulip: "Tulipa Nereida", fern: "Feto de Pã", helios: "Botão de Hélio",
        peony: "Peónia Psique", hydra: "Hortênsia Hidra", lily: "Lírio Fénix", sunflower: "Girassol de Rá", lavender: "Lavanda Morfeu",
        rose: "Rosa Valquíria", orchid: "Orquídea Íris", cactus: "Cacto Golem", holo: "Holo Bloom", axiom: "Axiom Tree",
      },
      errors: {
        "Not enough Holo Shards": "Holo Shards insuficientes",
        "Needs level 8": "Precisa de nível 8",
        "Things overlap": "Há coisas sobrepostas",
        "That doesn't fit inside the plot": "Não cabe dentro do terreno",
        "That tile is reserved": "Esse quadrado está reservado",
        "Harvest or wait before storing a bed with plants": "Não podes guardar um canteiro com plantas",
      },
    },
    challenges: {
      how: "Como funcionam os desafios?",
      title: "Desafios da semana",
      ends: "Novos em {t}",
      claim: "Receber",
      claimed: "Recebido",
      bonus: "Os 3 feitos: Promo Pack",
      ready_n: "{n} por receber",
      bonus_claim: "Abrir bónus",
      got: "Prémio recebido!",
      items: {
        harvest5: "Colhe 5 plantas", water8: "Rega 8 vezes", plant4: "Planta 4 sementes", plantrare: "Planta uma semente Rara ou Lendária",
        fish3: "Pesca 3 peixes", chest3: "Abre 3 baús diários", vote3: "Vota em 3 listagens", comment2: "Escreve 2 comentários", feed3: "Alimenta a Pixie 3 vezes", support3: "Apoia 3 lojas diferentes ⚡",
      },
      reward: { xp: "+{n} XP", seeds: "{n} sementes", food: "1 {f}", decor: "{d}" },
    },
    growth: {
      unlock_at: "Desbloqueia no nível {n}",
      level_n: "Nível {n}",
      seed_banner: "Guarda a tua frase de recuperação: sem ela não recuperas a conta se te esqueceres da palavra-passe.",
      seed_now: "Guardar agora",
      later: "Depois",
      wb_title: "Bem-vindo(a) de volta!",
      wb_days: "Estiveste fora {n} dias. A Pixie guardou-te um presente:",
      wb_shards: "+{n} Holo Shards",
      wb_new: "{n} entradas novas desde a tua última visita",
      wb_unread: "{n} notificações à tua espera",
      wb_chest: "O teu baú diário está pronto.",
      wb_go: "Bora",
      wf_hi: "Olá, {u}!",
      wf_games_title: "O que jogas?",
      skip_all_short: "Saltar por agora",
      wf_lede: "2 perguntas rápidas para te mostrarmos o que há perto de ti.",
      city: "A tua cidade",
      city_private: "Só tu a vês. Serve para te sugerir lojas e eventos perto de ti.",
      city_none: "Prefiro não dizer",
      games: "Os teus jogos favoritos",
      games_hint: "Escolhe quantos quiseres.",
      more_games: "Mais jogos",
      search_games: "Procurar jogos…",
      other: "Outro",
      other_ph: "Que jogo?",
      next: "Continuar",
      skip: "Saltar",
      skip_all: "Saltar a introdução",
      wf_stores_title: "Lojas perto de ti",
      wf_stores_lede: "Já foste a alguma? Vota ▲ ou ▼. Não sabes? Salta.",
      wf_stores_all: "Lojas de todo o país",
      wf_pack_title: "O teu primeiro pack",
      wf_pack_lede: "Um pack de boas-vindas para a Pixie. Abre-o e vê o que te sai!",
      wf_open: "Abrir o pack",
      fs_title: "Primeiros passos",
      fs_lede: "Completa estas missões para ganhar XP extra.",
      fs: {
        vote3: "Vota em 3 entradas",
        chest1: "Abre o teu baú diário",
        comment1: "Deixa um comentário",
        equip1: "Equipa um item na Pixie",
      },
      fs_toast: "Missão cumprida: {q}",
      ref_title: "Convida amigos",
      ref_both: "Tu E o teu amigo ganham",
      ref_pack: "Pack",
      ref_lede: "Quando um amigo entra com o teu link e completa as primeiras tarefas, ganham os dois 1 pack, 100 XP, 30 Holo Shards e um Bubble Tea.",
      ref_link: "O teu link",
      ref_code: "O teu código",
      ref_copy: "Copiar",
      ref_share: "Partilhar",
      ref_share_text: "Junta-te a mim no tierTCG, a tier list do TCG em Portugal:",
      ref_month: "Recompensados este mês: {n}/{max}",
      ref_rules: "As tarefas deles (em {d} dias): votar em {v} entradas diferentes, deixar {c} comentários com {m}+ caracteres, abrir o baú em {ch} dias diferentes e guardar a frase de recuperação. Contas criadas no teu dispositivo ou na tua rede não contam.",
      ref_friends: "Os teus amigos",
      ref_none: "Ainda não convidaste ninguém.",
      ref_status: { pending: "Em curso", done: "Concluído", expired: "Expirou", blocked: "Não conta", cap: "Limite do mês", cancelled: "Cancelado" },
      ref_mine: "Convidado(a) por @{u}: completa isto para receberes a recompensa",
      ref_task: { votes: "Votos", comments: "Comentários", chest_days: "Dias de baú", phrase: "Frase guardada" },
      ref_land_title: "@{u} convidou-te para o tierTCG",
      ref_land_lede: "A tier list do TCG em Portugal: lojas, eventos e criadores, avaliados por nós e votados pela comunidade. E a tua própria Pixie.",
      ref_land_cta: "Criar a minha conta",
      ref_land_have: "Já tens conta? Entrar",
      ref_land_bad: "Este link de convite não funciona, mas podes entrar na mesma.",
      ref_field: "Código de convite (opcional)",
      prefs_title: "A tua cidade e jogos",
      saved: "Guardado",
      save: "Guardar",
    },
    soon: {
      title_tag: "Em breve",
      eyebrow: "Em breve",
      h1a: "A tier list",
      h1b: "definitiva",
      h1c: "do TCG português",
      text: "Lojas, máquinas de vending, eventos e criadores, avaliados por nós e votados pela comunidade. Estamos a pôr as últimas cartas no lugar.",
      pixie_lines: ["Quase pronto!", "A baralhar as cartas…", "Até já!", "A polir os rankings…"],
      days: "dias", hours: "horas", mins: "min", secs: "seg",
      opens_on: "Abre a {d}",
      follow: "Segue o lançamento no Instagram",
      tester_link: "Tens uma conta de teste? Entrar",
      tester_title: "Conta de teste",
      user: "Utilizador ou email",
      pass: "Palavra-passe",
      enter: "Entrar",
      no_access: "Esta conta ainda não pode entrar antes do lançamento.",
      bad_login: "Utilizador ou palavra-passe errados.",
      too_many: "Demasiadas tentativas. Tenta daqui a 15 minutos.",
      by: "a equipa tierTCG",
    },
    install: {
      title: "O tierTCG no teu ecrã inicial",
      text: "Abre os rankings e a tua Pixie com um toque, como uma app.",
      ios: "Toca em Partilhar e depois em \u201cAdicionar ao ecrã principal\u201d.",
      add: "Adicionar",
      close: "Fechar",
    },
    notfound: {
      title: "A Pixie perdeu-se",
      text: "Esta página não existe (ou mudou de sítio). A Pixie procurou por todo o lado e só encontrou pó.",
      home: "Voltar ao início",
      rankings: "Ver os rankings",
    },
    empty: {
      comments_title: "Ainda sem comentários",
      comments_hint: "Vota primeiro e sê o primeiro a dizer o que achas.",
      bucket_title: "Balde vazio",
      bucket_hint: "Apanha uns peixes e o Mr Ducky compra-tos.",
      go_fish: "Ir pescar",
      notif_title: "Tudo calmo",
      notif_hint: "O teu baú, os iscos e as respostas aparecem aqui.",
      ranking_title: "Ainda não há nada aqui",
    },
    history: {
      title: "Histórico no ranking",
      chart_title: "Posição no ranking tierTCG ao longo do tempo",
      chart_community: "Posição no ranking da comunidade ao longo do tempo",
      tab_community: "Comunidade",
      chart_soon: "O gráfico aparece quando houver alguns dias de histórico do ranking.",
      reviews_title: "Avaliações tierTCG",
      current: "Atual",
      rank: "Posição",
    },
    seal: {
      button: "Selo Top tierTCG",
      title: "Selo Top tierTCG",
      lede: "Descarrega ou imprime o teu certificado para a porta, a montra ou as redes sociais. O código QR abre a tua página no tierTCG.",
      tab_tiertcg: "Ranking tierTCG",
      tab_community: "Ranking da comunidade",
      month_note: "O certificado mostra o mês em que foi criado. Cria um novo todos os meses para mostrar onde estás agora.",
      poster: "Cartaz",
      certificate: "Certificado",
      print: "Imprimir",
      download: "Descarregar PNG",
      download_failed: "Não foi possível criar a imagem",
      scan: "Lê o código para ver a avaliação",
      team: "A equipa tierTCG",
      owner_only: "Só o dono verificado desta entrada pode aceder ao selo.",
      not_eligible: "Os certificados estão disponíveis para o top 10 do ranking tierTCG ou do ranking da comunidade de cada categoria.",
      not_found: "Entrada não encontrada.",
    },
    recovery: {
      overline: "Segurança da conta",
      title: "Guarda a tua frase de recuperação",
      warn_only_way: "Esta frase é a ÚNICA forma de recuperares a tua conta ou mudares uma password esquecida.",
      warn_nobody: "Só guardamos uma versão encriptada, por isso ninguém — nem a equipa tierTCG — a consegue ver ou voltar a enviar-ta.",
      warn_share: "Nunca a partilhes. Quem tiver estas 12 palavras pode ficar com a tua conta.",
      copy: "Copiar frase",
      copied: "Copiado!",
      copy_failed: "Não foi possível copiar — escreve as palavras num papel",
      i_saved: "Copiei a minha frase de recuperação e guardei-a num local seguro (gestor de passwords, notas, papel).",
      continue: "Continuar",
      saved_ok: "Frase de recuperação guardada. Está tudo pronto!",
      reissued: "Essa frase expirou — aqui tens uma nova.",
      phrase_label: "Frase de recuperação (12 palavras)",
      phrase_placeholder: "palavra1 palavra2 palavra3 …",
      why_asked: "Por segurança, alterações à conta pedem a tua frase de recuperação.",
      forgot: "Esqueceste-te da password?",
      recover_overline: "Recuperar conta",
      recover_title: "Nova password",
      recover_lede: "Indica o teu username ou email, a frase de recuperação de 12 palavras que guardaste ao criar a conta, e uma nova password.",
      recover_cta: "Mudar password",
      recovered: "Password alterada — bem-vindo de volta!",
      need_12: "A frase de recuperação tem 12 palavras.",
      lost_phrase: "Também perdeste a frase? Envia-nos um email a partir do endereço da tua conta:",
      set_new_title: "Define a tua nova password",
      set_new_lede: "Entraste com uma password temporária. Escolhe uma nova password para continuar.",
      set_new_cta: "Guardar nova password",
      repeat_password: "Repetir nova password",
      no_match: "As passwords não coincidem.",
      password_set: "Nova password guardada",
    },
    gems: {
      desc_short: "A tua gema mostra o teu nível. A cada 5 níveis ganhas uma gema nova.",
      title: "Gemas",
      desc: "A tua gema mostra o teu nível. Ganha XP a votar, comentar, abrir o baú diário e jogar com o teu Pixie. A cada 5 níveis desbloqueias uma gema nova e uma nova cor do anel à volta da tua foto de perfil.",
      you_are: "Estás no nível {n}",
      they_are: "@{u} está no nível {n}",
      here: "Estás aqui",
      now: "Atual",
      levels_left: "Faltam {n} níveis",
      levels_left_one: "Falta 1 nível",
      what: "O que são gemas?",
      names: { quartzo: "Quartzo", ametista: "Ametista", esmeralda: "Esmeralda", safira: "Safira", topazio: "Topázio", rubi: "Rubi", diamante: "Diamante", ouro: "Ouro tierTCG", prisma: "Prisma" },
    },
    pixo: {
      booster: "Pack 1ª Ed.",
      your_pixo: "O teu Pixie",
      name: "Pixie",
      someones: "Pixie de {u}",
      hellos: ["Olá!", "Bem-vindo!", "Já votaste hoje?", "Bora explorar?", "Olá, olá!", "Descobre a tua loja!"],
      fish: {
        go: "Ir pescar",
        title: "Ir pescar",
        bait: "Iscos {n}/{max}",
        bait_short: "{n} iscos",
        refill_in: "5 iscos novos à meia-noite · {t}",
        dex: "Fishdex",
        dex_count: "Fishdex {n}/{total}",
        cast: "Lançar!",
        pull: "Puxar",
        pull_now: "Puxar!",
        pulling: "A puxar…",
        again: "Lançar de novo",
        no_bait: "Sem iscos",
        hint_idle: "Um só botão: carrega para lançar a linha. Também podes tocar no lago.",
        hint_wait: "Espera pela dentada. Se puxares cedo demais, o peixe foge.",
        hint_bite: "Carrega quando a barra branca estiver na zona verde.",
        hint_none: "Os iscos voltam 24 horas depois do primeiro lançamento.",
        hint_caught: "Peixes raros e lendários podem trazer um pack.",
        early: "Puxaste cedo demais! O peixe fugiu.",
        escaped: "Escapou!",
        got: "Apanhaste!",
        new_dex: "Novo no Fishdex",
        record: "novo recorde!",
        pack: "Sorte! Ganhaste 1 Pack 1ª Ed.",
        pack_plain: "Ganhaste 1 Pack 1ª Ed.",
        hat: "Chapéu de Pescador · exclusivo",
        gold_rod: "Cana Dourada · exclusiva",
        continue: "Continuar",
        caught_n: "Apanhados {n} / {total}",
        dex_hint: "Peixes raros podem trazer um pack. O Grail Fish pode dar o Chapéu de Pescador e a Cana Dourada (1 em cada 2).",
        record_cm: "recorde {cm} cm",
        show: "Mostrar no perfil",
        showing: "Em exibição",
        rod: "Cana",
        rods: { wood: "Cana de madeira", gold: "Cana Dourada" },
        failed: "Algo correu mal. Tenta outra vez.",
      },
      fish_names: {
        sleevefish: "Sleevefish", pebble_perch: "Pebble Perch", shuffle_shad: "Shuffle Shad", bulk_carp: "Bulk Carp",
        penny_minnow: "Penny Minnow", dice_dace: "Dice Dace", foilfin: "Foilfin", mintscale: "Mintscale",
        deckbox_pike: "Deckbox Pike", playmat_ray: "Playmat Ray", holo_koi: "Holo Koi", prism_eel: "Prism Eel",
        booster_bass: "Booster Bass", grail_fish: "Grail Fish",
      },
      chest: "Baú diário",
      chest_ready: "Abrir!",
      chest_in: "em {t}",
      chest_title: "Baú diário",
      chest_desc: "Um baú novo a cada 24 horas: XP, comida, packs 1ª Edição e Holo Shards.",
      chest_open: "Abrir baú",
      chest_failed: "O baú ainda não está pronto",
      chest_got: "Recebeste",
      packs: "Packs",
      pack_god: "GOD PACK",
      pack_count: "{n}× Pack 1ª Ed.",
      god_pack: "God pack",
      god_desc: "Um item de cada raridade!",
      food: "Comida",
      eat: "Comer",
      eating: "Nham!",
      eat_failed: "Não foi possível comer",
      glow_on: "Brilho dourado durante 7 dias!",
      glowing_until: "A brilhar até {d}",
      no_food: "Ainda sem comida. Abre o teu baú diário!",
      foods: {
        cookie: "Bolacha",
        onigiri: "Onigiri",
        bubble_tea: "Bubble Tea",
        strawberry_cake: "Bolo de morango",
        fortune_cookie: "Bolacha da Sorte",
        golden_nata: "Pastel de Nata Dourado",
      },
      boosters: "Packs",
      rip_packs: "Abre packs",
      edition: { 1: "1ª Edição" },
      edition_short: { 1: "1ª Ed." },
      exclusive_fishing: "Só a pescar",
      exclusive_treasure: "Só em baús enterrados",
      serial_one: "Nº {n}",
      serial_many: "Os teus nºs: {n}",
      exclusive_founder_how: "Oferecido aos primeiros 151 membros do tierTCG. O número é a tua ordem de registo.",
      exclusive_garden: "Só a colher no jardim (raro)",
      exclusive_support: "30 dias seguidos de apoio ⚡",
      open_boosters: "Abrir packs",
      milestone_booster: "Promo Pack",
      open: "Abrir",
      open_next: "Abrir próximo",
      pick_pack: "Escolhe um pack",
      pick_pack_hint: "Tens mais do que um tipo de pack.",
      change_pack: "Escolher outro pack",
      pack_desc: { god: "Um cosmético de cada raridade", ed1_plus: "Raro ou melhor garantido", ed1: "Cosmético ou boost de XP" },
      no_boosters: "Sem packs",
      open_failed: "Não foi possível abrir o pack",
      new_item: "Novo!",
      xp_boost: "Bónus de XP",
      equip: "Equipar",
      equipped: "Equipado",
      equipped_ok: "Equipado!",
      equip_failed: "Não foi possível equipar",
      close: "Fechar",
      inventory: "Inventário",
      collection: "Coleção",
      tap_to_equip: "toca num item para o equipar",
      rarity: { common: "Comum", uncommon: "Incomum", rare: "Raro", legendary: "Lendário" },
      slots: { all: "Tudo", head: "Cabeça", eyes: "Olhos", back: "Costas", hand: "Mão", effect: "Efeito", pin: "Pin" },
      items: {
        cap: "Boné",
        bow: "Laço",
        heart_glasses: "Óculos de coração",
        bandana: "Bandana",
        card_backpack: "Deck Bag",
        pirate_hat: "Chapéu de Pirata",
        founder_pin: "Pin de Fundador",
        gardener_hat: "Chapéu de Jardineiro",
        star_plush: "Peluche estrela",
        sunglasses: "Óculos de sol",
        bunny_ears: "Orelhas de coelho",
        champion_crown: "Coroa de campeão",
        magic_wand: "Varinha mágica",
        sleeve_cape: "Capa de sleeve",
        pixel_wings: "Asas de pixel",
        holo_aura: "Aura holo",
        fisherman_hat: "Chapéu de Pescador",
        beanie: "Gorro",
        cat_ears: "Orelhas de Gato",
        beanie_badge: "Gorro com Pin",
        top_hat: "Cartola de Mágico",
        lynx_ears: "Orelhas de Lince",
        lightning_scepter: "Cetro do Raio",
      },
    },
    eco: {
      quick: {
        buy: "Comprar",
        poor: "Ainda não tens Holo Shards suficientes.",
        duck_ticket: { title: "Duck Ticket: +2 vendas hoje", sub: "O Mr Ducky compra-te mais 2 peixes hoje." },
        bait3: { title: "3 iscos extra", sub: "Continua a pescar já, sem esperar pelo reabastecimento." },
      },
      "shards": "Holo Shards",
      "wallet": "Carteira",
      "wallet_desc": "Os Holo Shards ganham-se a usar o site. Não se compram com dinheiro e não mexem nos rankings.",
      "reasons": {
        "mystery_bag": "Saco Mistério",
        "airdrop": "Airdrop",
        "suggestion_approved": "Sugestão aprovada",
        "chest": "Baú diário",
        "vote": "Voto",
        "comment": "Comentário",
        "comment_deleted": "Comentário apagado",
        "streak": "Sequência de 7 dias",
        "new_gem": "Gema nova",
        "break": "Duplicados partidos",
        "ducky": "Mr Ducky",
        "shop": "Loja",
        "buried_chest": "Baú enterrado",
        "admin": "Equipa tierTCG"
      },
      "shop": "Loja",
      "shop_always": "Sempre à venda",
      "shop_week": "Esta semana",
      "shop_rotation": "Rotação {n}",
      "ends_in": "Acaba em {t}",
      "one_each": "1 de cada por conta",
      "no_cosmetics": "Sem cosméticos à venda: o que o teu Pixie veste ganha-se a jogar.",
      "buy_ok": "Compraste {item}",
      "mystery_open": "Toca para abrir!",
      "mystery_got": "Encontraste",
      "mystery_new": "Nova para a tua Plantdex!",
      "mystery_ok": "Boa!",
      "mystery_pack": "+{n} Pack 1.ª Edição!",
      "mystery_bonus": "+{x} XP · +{s} Holo Shards",
      "no_funds": "Não tens shards suficientes.",
      "limit_hit": "Limite atingido.",
      "bought": "Comprado",
      "buy_failed": "Não foi possível comprar",
      "lim": {
        "day": "{n}/dia",
        "snack": "snacks {n}/dia",
        "one": "1 de cada vez",
        "week": "1 por conta",
        "ever": "1 por conta"
      },
      "items": {
        "bait3": "+3 Iscos",
        "lucky_lure": "Isco da Sorte",
        "steady_line": "Linha Firme",
        "duck_ticket": "Senha do Mr Ducky",
        "treasure_map": "Mapa do Tesouro",
        "fortune_cookie": "Bolacha da Sorte",
        "cookie": "Bolacha",
        "bubble_tea": "Bubble Tea",
        "strawberry_cake": "Bolo de morango",
        "jar_rain": "Frasco do Tempo · Chuva",
        "jar_fog": "Frasco do Tempo · Nevoeiro",
        "jar_sun": "Frasco do Tempo · Sol",
        "jar_storm": "Frasco do Tempo · Tempestade",
        "anglers_kit": "Kit do Pescador",
        "two_maps": "Dois Mapas",
        "snack_box": "Caixa de Snacks",
        "lucky_week": "Semana da Sorte",
        "seed_packet": "Pacote de Sementes",
        "mystery_seeds": "Saco de Sementes Mistério",
        "garden_stones": "Pedras do Caminho",
        "garden_lantern": "Lanterna de Jardim",
        "garden_bench": "Banco de Jardim",
        "garden_bed": "Canteiro"
      },
      "desc": {
        "bait3": "Pesca mais hoje.",
        "seed_packet": "3 sementes de jardim ao calhas. Muito raramente, uma é lendária.",
        "mystery_seeds": "Uma semente surpresa e um item. É um mistério o que pode vir lá dentro.",
        "garden_stones": "Pedras do caminho para o teu jardim.",
        "garden_lantern": "Uma lanterna acolhedora para o teu jardim.",
        "garden_bench": "Um banco para o teu jardim (2 quadrados).",
        "garden_bed": "Mais um canteiro: mais 2 plantas.",
        "lucky_lure": "Peixes comuns com metade da probabilidade nos próximos 3 lançamentos. Não é garantido.",
        "steady_line": "Zona de captura maior nos próximos 3 lançamentos.",
        "duck_ticket": "Hoje o Mr Ducky compra mais 2 peixes.",
        "treasure_map": "3 baús diários, 3 peças, 1 baú enterrado.",
        "fortune_cookie": "+5 XP e uma sorte, às vezes com efeito.",
        "cookie": "+5 XP",
        "bubble_tea": "+12 XP",
        "strawberry_cake": "+30 XP",
        "jar_rain": "24 h de chuva no teu lago: mais peixes Incomuns.",
        "jar_fog": "24 h de nevoeiro: mais hipóteses de peixes Raros.",
        "jar_sun": "24 h de sol: os peixes mordem mais depressa.",
        "jar_storm": "24 h de tempestade: o Grail Fish morde o dobro das vezes.",
        "anglers_kit": "3 Iscos da Sorte + 3 iscos.",
        "two_maps": "2 Mapas do Tesouro, usados um a seguir ao outro.",
        "snack_box": "1 Bolo de morango, 2 Bubble Tea, 3 Bolachas da Sorte.",
        "lucky_week": "1 Mapa do Tesouro + 3 Bolachas da Sorte."
      },
      "crack_now": "Partir agora",
      "weather": {
        "rain": "Chuva",
        "fog": "Nevoeiro",
        "sun": "Sol",
        "storm": "Tempestade"
      },
      "fortune_title": "Bolacha da Sorte",
      "crack": "Partir",
      "fortune_used": "Já partiste uma hoje. Volta amanhã.",
      "fortune_effect": "Efeito: {e}",
      "fortune_lasts": "O efeito dura até ao fim do dia.",
      "fortune_plain": "+5 XP. Sem efeito desta vez.",
      "one_a_day": "1 por dia",
      "fortunes": {
        "ducky": "O Mr Ducky gosta de ti hoje.",
        "calm": "A água está calma.",
        "hungry": "O peixe procurado tem fome.",
        "homes": "Itens velhos encontram casa nova.",
        "glint": "Um brilho na areia.",
        "p1": "Um pull raro está mais perto do que parece.",
        "p2": "Vota com o coração, comenta com a cabeça.",
        "p3": "Todo o binder começa com uma carta.",
        "p4": "A paciência apanha o maior peixe.",
        "p5": "Hoje é um bom dia para abrir um pack."
      },
      "effects": {
        "ducky": "+1 peixe vendido ao Mr Ducky hoje",
        "calm": "Zona de captura maior hoje",
        "hungry": "Peixe procurado paga ×4 hoje",
        "homes": "Duplicados valem +50% hoje",
        "glint": "Próximo baú traz 2 peças"
      },
      "lure_on": "Isco da Sorte pronto",
      "line_on": "Linha Firme ×{n}",
      "map": "Mapa",
      "map_piece": "Peça do mapa {n}/3",
      "map_complete": "Mapa completo!",
      "map_count": "Mapa do tesouro: {n}/3 peças",
      "dig_now": "Ir escavar",
      "go_dig": "Mapa completo · ir escavar!",
      "treasure_map": "Mapa do tesouro",
      "dig_title": "Baú enterrado",
      "dig_btn": "Escavar!",
      "dig_desc": "O teu mapa está completo. O teu Pixie escava no X.",
      "dig_found": "O teu Pixie desenterrou o tesouro!",
      "got": "Recebeste",
      "pack": "Pack",
      "digging": "A escavar…",
      "pirate_hat_found": "Chapéu de Pirata!",
      "pirate_hat_sub": "Exclusivo · só em baús enterrados · 1%",
      "buried_progress": "Baús enterrados: {n}/{t} para a conquista Pirata",
      "pirate_unlocked": "Nova conquista: Pirata!",
      "next_map": "O teu próximo mapa já está ativo.",
      "streak": "Sequência de {n} dias",
      "ducky": "Mr Ducky",
      "ducky_more": "Hoje pago mais {p}! Quack.",
      "ducky_less": "Dia fraco: hoje pago menos {p}. Quack.",
      "ducky_same": "Preços normais hoje. Quack.",
      "board_more": "Hoje +{p}!",
      "board_less": "Hoje −{p}",
      "board_same": "Preço normal",
      "ducky_wanted": "Procurado hoje: {f}",
      "ducky_wanted_sub": "O primeiro que venderes paga ×{x}",
      "ducky_wanted_done": "Já pago hoje",
      "ducky_bucket": "O teu balde",
      "ducky_sold": "Vendidos hoje {n}/{max}",
      "stall": "Banca Mr Ducky",
      "ach_unlocked": "Conquista desbloqueada",
      "pirate_found10": "Encontraste 10 baús enterrados.",
      "to_shop": "Ir à loja",
      "sell": "Vender",
      "sold_ok": "O Mr Ducky pagou {n} shards",
      "ducky_no_legend": "Lendário: não compra",
      "ducky_note": "Vender só esvazia o balde: o peixe fica no Fishdex para sempre.",
      "ducky_limit": "O Mr Ducky não compra mais hoje.",
      "wanted": "procurado",
      "stays": "Fica no Fishdex",
      "new": "novo",
      "break_n": "Partir {n} · +{v}",
      "break_ok": "Partiste os duplicados · +{n} shards",
      "no_dupes": "Sem duplicados",
      "you_have": "tens ×{n}",
      "set1": "1ª Edição · Set 1",
      "exclusives": "Exclusivos",
      "snacks": "Snacks",
      "excl_note": "Os exclusivos não se compram: cada um conquista-se de uma forma especial.",
      "exclusives_n": "Exclusivos {n}/{t}",
      "signup": {
        "title": "Entra para",
        "title_hl": "votar",
        "lede": "Os votos só contam com conta. Criar uma é grátis e leva 30 segundos.",
        "create": "Criar conta grátis",
        "login": "Já tenho conta · Entrar",
        "foot": "Sem microtransações. 100% stress free.",
        "perks": [
          [
            "O teu voto conta!",
            "Ajuda a decidir o ranking."
          ],
          [
            "Níveis e conquistas",
            "Sobe de nível, ganha gemas e medalhas."
          ],
          [
            "O teu próprio Pixie!",
            "Veste-o com itens 1ª Edição tirados de packs."
          ],
          [
            "Baú diário",
            "Tenta a tua sorte!"
          ],
          [
            "Mini jogos!",
            "Pescar, e mais no futuro."
          ]
        ]
      },
      "admin": {
        "title": "Holo Shards",
        "circulation": "Em circulação",
        "adjust": "Dar / tirar shards",
        "amount": "Quantidade (+ ou −)",
        "note": "Nota",
        "apply": "Aplicar",
        "log": "Últimos movimentos",
        "user": "Membro",
        "reason": "Motivo",
        "when": "Quando",
        "done": "Feito"
      }
    },
    badges: {
      title: "Conquistas",
      seniority_label: "Nível de membro",
      seniority_short: "Sobe com o tempo que fazes parte do tierTCG.",
      seniority_desc: "Sobe quanto mais tempo fazes parte do tierTCG: Comum (menos de 1 semana), Incomum (1 semana a 3 meses), Raro (3 a 6 meses), Holo (6 meses a 1 ano), Mítico (1 a 2 anos), Lendário (2 anos ou mais).",
      first_vote_desc: "Dá o teu primeiro voto na comunidade.",
      first_comment_desc: "Publica o teu primeiro comentário.",
      comments_10_desc: "Publica 50 ou mais comentários.",
      comments_50_desc: "Publica 500 ou mais comentários.",
      explorer_desc: "Atribuída por votares nas três categorias: lojas, eventos e criadores.",
      early_supporter_desc: "Um dos primeiros 151 membros do tierTCG.",
      top_reviewer_desc: "Estar atualmente no top 50 de membros com mais comentários.",
      how_earned: "Como se ganha",
      how_unlock: "Como desbloquear",
      unlocked_on: "Desbloqueada a",
      unlocked: "Desbloqueada",
      locked: "Bloqueada",
      members_have: "{p}% dos membros têm esta",
      member_since: "Membro desde",
      close: "Fechar",
      common: "Comum",
      uncommon: "Incomum",
      rare: "Raro",
      holo: "Holo",
      mythic: "Mítico",
      legendary: "Lendário",
      first_vote: "Votador",
      first_comment: "Comentador",
      comments_10: "Opinado",
      comments_50: "Comentador de Rádio",
      explorer: "Explorador",
      early_supporter: "Fundador",
      top_reviewer: "Top Reviewer",
      pirate: "Pirata",
      pirate_desc: "Desenterra 10 baús com Mapas do Tesouro.",
      recruiter: "Recrutador",
      recruiter_desc: "Traz 3 amigos que completem as primeiras tarefas.",
      green_thumb: "Mão Verde",
      green_thumb_desc: "Colhe as 16 plantas do Herbário do teu jardim.",
      visionario: "Visionário",
      visionario_desc: "Deu pelo menos 10 apoios ⚡ à loja campeã durante essa temporada.",
      supporter: "Apoiante",
      supporter_desc: "Apoia o tierTCG. Obrigado! 💛",
      comments_short: "comentários",
      request_verification: "Pedir afiliação",
      affiliation_title: "Pedir afiliação",
      affiliation_subtitle: "Prova a tua ligação a esta entrada para receberes a verificação.",
      affiliation_name: "O teu nome",
      affiliation_name_ph: "Nome completo",
      affiliation_submit: "Enviar pedido",
      affiliation_cancel: "Cancelar",
      affiliation_message_required: "Por favor diz-nos quem és.",
      affiliation_account: "A tua conta",
      affiliation_role: "A tua função",
      affiliation_roles: { owner: "Dono", representative: "Representante" },
      affiliation_context: "Contexto",
      affiliation_context_ph: "Qual é a tua ligação a esta entrada? Há outras contas que devam ficar associadas?",
      affiliation_role_required: "Escolhe a tua função.",
      affiliation_login_title: "Entra primeiro",
      affiliation_login: "Para pedires afiliação precisas de uma conta tierTCG: é assim que te respondemos e ligamos esta entrada ao teu perfil.",
      affiliation_login_btn: "Entrar",
      affiliation_register_btn: "Criar conta",
      affiliation_sent: "Pedido enviado. Acompanha-o em Os meus tickets.",
      affiliation_limit: "Podes enviar até 3 pedidos por dia.",
      reply: "Responder",
    },
    category: {
      curated: "Ranking tierTCG",
      community: "Ranking Comunidade",
      curated_lede: "Classificadas com base em critérios justos e na experiência pessoal da equipa tierTCG.",
      community_lede: "Composto ao vivo pelos votos da comunidade — são as pessoas que decidem onde cada entrada aterra.",
      search: "Pesquisar entradas...",
      loading: "A carregar rankings...",
      empty: "Ainda sem entradas.",
      empty_cta_prefix: "Não encontras a tua",
      empty_cta_suffix: "? Faz uma sugestão aqui",
      empty_cta_link: "sugerir",
      empty_cta_labels: {
        stores: "loja TCG favorita",
        creators: "criador favorito",
        vending: "máquina de vending favorita",
        events: "feira de cartas favorita",
        vendors: "vendedor favorito",
      },
      verified: "Verificado",
      verified_lede: "Verificado pessoalmente pela tierTCG",
      rank: "Posição",
      overall: "Pontuação",
      show: "Critérios",
      hide: "Ocultar Critérios",
      visit: "Visitar site",
      score: "Nota",
      experience: "A Nossa Opinião",
      hide_experience: "Ocultar Opinião",
      pos: "Pos",
      upvotes: "Sobe",
      downvotes: "Desce",
      net: "Net",
      total_votes: "Total de votos",
      move: "Tendência",
      trending: "Em subida",
      trending_hint: "Maior subida esta semana",
      new_entry: "Nova entrada",
      move_up: "Subiu {n} desde a semana passada",
      move_down: "Desceu {n} desde a semana passada",
      move_same: "Mesma posição da semana passada",
      positive: "positivo",
      vote_one: "voto",
      votes_many: "votos",
      few_votes: "Poucos votos",
      few_votes_hint: "Menos de 5 votos: a posição ainda pode mudar muito.",
      how_link: "Como funciona o ranking?",
      how_title: "Como funciona o ranking da comunidade",
      how_short: [
        "Cada membro tem um voto por entrada: ▲ ou ▼. Podes mudá-lo quando quiseres.",
        "A ordem olha para a percentagem de votos positivos, mas cada entrada começa com 2 ▲ e 2 ▼ “neutros”. Assim, com poucos votos ninguém sobe nem cai demasiado: 30 ▲ e 0 ▼ fica acima de 1 ▲ e 0 ▼, e 1 ▼ sozinho não afunda uma loja.",
        "Quanto mais votos uma entrada tem, mais o seu lugar depende da sua % positiva real. Entradas com menos de 5 votos levam a etiqueta “Poucos votos”.",
        "O ranking tierTCG é a avaliação da nossa equipa, feita em visitas reais; os votos não o mudam. Uma nova visita pode subir ou descer a nota.",
      ],
      vote_locked: "Já votaste. Podes mudar entre ▲ e ▼, mas não retirar o voto.",
      vote_toast_up: "Voto contado ▲",
      vote_toast_down: "Voto contado ▼",
      vote_toast_desc: "{pct}% positivo · {n} votos",
      share: "Partilhar",
      comments: "Comentários",
      comments_lede: "O que a comunidade está a dizer",
      comment_placeholder: "Diz o que achas (máx 100 caracteres)...",
      comment_submit: "Publicar comentário",
      comment_vote_required: "Vota primeiro para deixar um comentário.",
      comment_login_tail: "para deixar um comentário.",
      comment_already_posted: "Já deixaste o teu comentário nesta entrada.",
      comment_posted: "Comentário publicado",
      comment_failed: "Não foi possível publicar o comentário",
      reply: "Responder",
      reply_placeholder: "Escreve uma resposta (máx 200 caracteres)...",
      reply_post: "Publicar resposta",
      reply_posted: "Resposta publicada",
      hide_replies: "Esconder respostas",
      show_replies: "Ver {n} respostas",
      show_reply_one: "Ver 1 resposta",
      sort_label: "Ordenar comentários",
      sort_recent: "Recentes",
      sort_top: "Top",
      like: "Gosto",
      unlike: "Retirar gosto",
      delete: "Apagar",
      delete_confirm: "Apagar este comentário?",
      deleted_ok: "Comentário apagado",
      comment_deleted: "Comentário apagado",
      report: "Denunciar",
      report_prompt: "Porque é que este comentário é inapropriado? (opcional)",
      reported: "Denunciado — um admin vai rever",
      owner_badge: "Dono",
    },
    share: {
      title: "Partilha este ranking",
      cta_title: "PARTILHA!",
      lede: "Faz download do cartão ou partilha diretamente — ostenta esse tier.",
      download: "Transferir imagem",
      copy: "Copiar link",
      copied: "Link copiado",
      hold_to_save: "Mantém o dedo na imagem e toca em “Guardar nas Fotos”.",
      done: "Feito",
      preparing: "A preparar imagem...",
      failed: "Não foi possível gerar a imagem",
    },
    finder: {
      near_on: "Ordenado pela distância a ti (por cidade)",
      near_clear: "Limpar",
      overline: "Encontra o teu lugar",
      title: "TCG Finder",
      lede: "Escolhe uma cidade e descobre as lojas TCG perto de ti.",
      all_cities: "Todas as cidades",
      filter_stores: "Lojas",
      filter_vending: "Vending",
      no_results: "Ainda não há lojas ou máquinas registadas nesta cidade.",
      show_all: "Ver todas as cidades",
      suggest: "Sugerir uma loja",
      results: "resultados",
    },
    vote: {
      overline: "A tua palavra conta",
      title: "Dá o teu voto",
      lede: "Escolhe uma categoria e decide onde cada entrada acaba no ranking da comunidade.",
      cta: "Votar agora",
      votes: "votos",
      rising: "Em alta",
    },
    explore: {
      overline: "Explorar",
      title: "Escolhe o teu ranking",
      lede: "Rankings verificados pela equipa tierTCG.",
      cta: "Ver ranking completo",
    },
    submit: {
      overline: "Conheces uma pérola escondida?",
      title: "Sugere uma entrada",
      lede: "Sugere uma loja TCG, criador ou evento que falte na lista. A sugestão vai para uma fila de aprovação — se encaixar, entra no ranking.",
      category: "Categoria",
      name: "Nome",
      location: "Localização (cidade ou plataforma)",
      website: "Website ou rede social",
      description: "Porque merece entrar?",
      your_name: "O teu nome (opcional)",
      your_email: "O teu email (opcional)",
      submit_cta: "Enviar para revisão",
      success: "Enviado! Vamos rever em breve.",
      failed: "Falha no envio",
      pick: "Escolhe uma categoria",
    },
    footer: {
      overline: "Supporters Oficiais",
      title: "Quem Apoia o tierTCG",
      lede:
        "Apoiam a manutenção e o desenvolvimento do tierTCG. Os rankings continuam independentes: o apoio nunca os influencia.",
      cta: "Torna-te Supporter",
      contact: "Fala connosco",
      follow: "Segue-nos",
      tagline: "Feito pela comunidade, para a comunidade.",
      copyright: "Os rankings TCG definitivos de Portugal",
    },
    admin: {
      overline: "tierTCG · Admin",
      title: "Entra no painel",
      lede: "Cura rankings, atualiza pontuações ponderadas e gere votos da comunidade.",
      email: "Email",
      password: "Palavra-passe",
      signin: "Entrar",
      signing: "A entrar...",
      welcome: "Bem-vindo, admin.",
      dash_overline: "Painel do Admin",
      dash_title: "Cura os rankings",
      signed_as: "Sessão iniciada como",
      logout: "Sair",
      new_entry: "Nova Entrada",
      entries_in: "entradas em",
      name: "Nome",
      location: "Localização",
      website: "Website",
      description: "Descrição",
      image_url: "URL da Imagem",
      experience: "A Nossa Opinião (visível ao público)",
      published: "Publicado (visível ao público)",
      verified: "Verificado (check dourado nas páginas públicas)",
      preview: "Pré-visualização",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      reset: "Repor Votos",
      draft: "Rascunho",
      confirm_delete: "Apagar esta entrada? Os votos também serão removidos.",
      confirm_reset: "Repor os votos da comunidade para esta entrada?",
    },
    toast: {
      created: "Entrada criada",
      updated: "Entrada atualizada",
      deleted: "Entrada apagada",
      votes_reset: "Votos repostos",
      save_failed: "Falha ao guardar",
      delete_failed: "Falha ao apagar",
      reset_failed: "Falha ao repor",
      name_required: "Nome obrigatório",
    },
    auth: {
      register_overline: "Junta-te à comunidade",
      register_title: "Cria o teu perfil",
      register_lede: "Escolhe um username para que os teus comentários sejam reconhecíveis. Votar continua anónimo.",
      register_cta: "Criar conta",
      registering: "A criar...",
      registered: "Bem-vindo!",
      register_failed: "Não foi possível criar a conta",
      limit_device: "Já foi criada uma conta neste dispositivo recentemente. Inicia sessão.",
      limit_ip: "Foram criadas demasiadas contas a partir desta ligação hoje. Tenta amanhã.",
      login_overline: "Bem-vindo de volta",
      login_title: "Entrar",
      login_cta: "Entrar",
      logging_in: "A entrar...",
      login_failed: "Credenciais inválidas",
      welcome: "Olá",
      username: "Username",
      username_hint: "3-10 caracteres, letras minúsculas, dígitos, _ ou .  Começa com uma letra.",
      username_placeholder: "joao_silva",
      email: "Email",
      password: "Palavra-passe",
      identifier: "Username ou email",
      already_have: "Já tens conta?",
      no_account: "Novo na tierTCG?",
      logout: "Sair",
      profile: "Perfil",
      sign_in: "Entrar",
      join: "Registar",
      member_since: "Membro desde",
      comments_count: "comentários",
      likes_count: "likes",
      like_one: "like",
      recent_comments: "Comentários recentes",
      no_comments: "Ainda sem comentários.",
      first_comment_cta: "Vota e comenta numa loja",
      edit_avatar: "Editar avatar",
      choose_avatar: "Escolhe o teu avatar",
      avatar_lede: "Escolhe um visual — só tu o podes mudar.",
      avatar_save: "Guardar",
      avatar_cancel: "Cancelar",
      avatar_saved: "Avatar atualizado",
      avatar_failed: "Não foi possível atualizar o avatar",
      settings: "Definições de conta",
      settings_short: "Definições",
      settings_lede: "Gere o teu email, palavra-passe e conta.",
      change_email: "Alterar email",
      new_email: "Novo email",
      change_email_cta: "Atualizar email",
      email_changed: "Email atualizado",
      change_password: "Alterar palavra-passe",
      new_password: "Nova palavra-passe",
      change_password_cta: "Atualizar palavra-passe",
      password_changed: "Palavra-passe atualizada",
      profile_deleted: "Este perfil foi eliminado.",
      settings_failed: "Algo correu mal",
    },
    legal: {
      overline: "tierTCG · Legal",
      about: {
        title: "Sobre a tierTCG",
        lede: "A autoridade independente de Portugal para lojas TCG, feiras de cartas e criadores.",
        sections: [
          {
            heading: "O que fazemos",
            body: "A tierTCG publica dois rankings por categoria: um ranking tierTCG curado com critérios ponderados transparentes e um ranking comunitário ao vivo moldado por upvotes, downvotes e comentários curtos dos jogadores portugueses.",
          },
          {
            heading: "Porquê",
            body: "Encontrar bons sítios de TCG em Portugal ainda depende do boca-a-boca. Estamos a construir a página única que podes mandar a quem está a entrar no hobby — honesta, verificável e bilingue.",
          },
          {
            heading: "Independência",
            body: "Os Supporters ajudam a pagar a manutenção e o desenvolvimento do site. O apoio fica separado dos rankings e nunca influencia a nota tierTCG nem os votos da comunidade.",
          },
          {
            heading: "Feito com a comunidade",
            body: "Fazemos o possível para manter tudo certo, mas há informação que muda depressa: horários, moradas, nomes, contactos. Se vires alguma coisa errada ou desatualizada numa loja, evento ou criador, manda-nos um ticket com a correção. Grande parte do que está no tierTCG foi melhorado por quem o usa, e cada correção ajuda a próxima pessoa.",
          },
        ],
      },
      terms: {
        title: "Termos de utilização",
        lede: "Ao usar a tierTCG aceitas as regras abaixo. Existem para manter o site útil e justo para todos.",
        sections: [
          {
            heading: "Contas",
            body: "Tens de ter pelo menos 13 anos para registar. És responsável pela segurança da tua conta. Os usernames têm de cumprir as regras publicadas e não podem fazer-se passar por negócios ou staff.",
          },
          {
            heading: "Votos e comentários",
            body: "Cada conta tem um voto por entrada, que podes mudar sempre que quiseres. Comentários limitados a 100 caracteres (respostas a 200), moderados e não editáveis depois de publicados, mas podes apagar os teus. Podes responder a comentários e dar gosto aos comentários de outras pessoas. Palavras ofensivas são automaticamente mascaradas. Abuso repetido leva à remoção da conta.",
          },
          {
            heading: "Sugestões",
            body: "Qualquer pessoa pode nomear uma nova entrada. As sugestões vão para uma fila de aprovação e só são publicadas se encaixarem nos critérios da tierTCG. Podemos editar descrições submetidas antes da publicação.",
          },
          {
            heading: "Alterações",
            body: "Podemos atualizar estes termos à medida que o site evolui. Continuar a usar o site após uma atualização significa que aceitas os novos termos.",
          },
        ],
      },
      privacy: {
        title: "Política de privacidade",
        lede: "O que a tierTCG recolhe, porquê, e durante quanto tempo.",
        sections: [
          {
            heading: "O que recolhemos",
            body: "Dados da conta (username, email, password em hash), votos, comentários, e um session id anónimo usado para contar visitantes distintos. Também registamos IP + user agent em eventos de voto e sugestão para prevenir abuso.",
          },
          {
            heading: "Porquê",
            body: "Para operar rankings, prevenir fraude eleitoral, moderar comentários e mostrar ao admin métricas agregadas. Nunca vendemos dados a terceiros.",
          },
          {
            heading: "Retenção",
            body: "Dados da conta ficam até apagares a conta. Eventos de voto e sessões expiram passados 24 meses. Exportações CSV contêm apenas contagens agregadas, nunca dados por utilizador. Os comentários apagados são guardados num registo interno de moderação.",
          },
          {
            heading: "Direitos (RGPD)",
            body: "Podes pedir acesso, correção ou eliminação dos teus dados pessoais a qualquer altura via página de contacto. Respondemos em 30 dias.",
          },
        ],
      },
      contact: {
        title: "Contacto",
        lede: "Dúvidas, sugestões, reclamações ou tornares-te Supporter: abre um ticket e respondemos aqui no site.",
        sections: [
          {
            heading: "Geral",
            body: "Abre um ticket no botão abaixo ou no rodapé.",
          },
          {
            heading: "Supporters",
            body: "Abre um ticket como marca / negócio.",
          },
        ],
      },
    },
  };
export default pt;
